<template>
  <div style="display: flex; flex-direction: column; gap: 4px">
    <span class="themed-column-text_top">{{ topText }}</span>
    <span class="themed-column-text_bottom">{{ bottomText }}</span>
  </div>
</template>

<script>
export default {
  name: "ThemedColumnText",
  props: {
    topText: String,
    bottomText: String,
  },
};
</script>

<style scoped>
.themed-column-text_top {
  font-size: 12px;
  font-weight: 300;
  color: var(--color-text);
}
.themed-column-text_bottom {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text);
}
</style>
